import React from "react";
import { useSelector } from "react-redux";

const ProfileCard = ()=>{
     const { user } = useSelector((state) => state.auth);
    
     return(
         <div className="profile-card">
        <div className="avatar-container">
          <img
            src={
              user?.avatar ||
              `https://ui-avatars.com/api/?name=${encodeURIComponent(
                `${user?.firstname || ""}+${user?.lastname || ""}`
              )}&background=random&size=150`
            }
            alt="User Avatar"
            className="profile-avatar"
            onError={(e) => {
              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                `${user?.firstname || ""}+${user?.lastname || ""}`
              )}&background=random&size=150`;
            }}
          />
        </div>

        <div className="profile-info">
          <h3 className="user-name">
            {user?.firstname} {user?.lastname}
          </h3>
          <p className="user-email">{user?.email}</p>

          <div className="info-row">
            <span className="info-label">EIS ID:</span>
            <span className="info-value">{user?.eisId}</span>
          </div>

          <div className="info-row">
            <span className="info-label">Role:</span>
            <span className="role-badge">{user?.role}</span>
          </div>

          <div className="info-row">
            <span className="info-label">Status:</span>
            <span
              className={`status-badge status-${user?.status?.toLowerCase()}`}
            >
              {user?.status}
            </span>
          </div>

          <div className="info-row">
            <span className="info-label">Subarea ID:</span>
            <span className="info-value">{user?.subareaId}</span>
          </div>
        </div>
      </div>
    )
}

export default React.memo(ProfileCard)